function T(l, t, o = "vertical", f = "smooth") {
  const c = {
    top: Math.round(
      l.getBoundingClientRect().top - t.getBoundingClientRect().top
    ),
    left: Math.round(
      l.getBoundingClientRect().left - t.getBoundingClientRect().left
    )
  }, s = c.top + t.scrollTop, g = c.left + t.scrollLeft, h = t.scrollLeft, p = t.scrollLeft + t.offsetWidth, e = t.scrollTop, i = t.scrollTop + t.offsetHeight;
  (o === "horizontal" || o === "both") && (g < h ? t.scrollTo({ left: g, behavior: f }) : g + l.clientWidth > p && t.scrollTo({
    left: g - t.offsetWidth + l.clientWidth,
    behavior: f
  })), (o === "vertical" || o === "both") && (s < e ? t.scrollTo({ top: s, behavior: f }) : s + l.clientHeight > i && t.scrollTo({
    top: s - t.offsetHeight + l.clientHeight,
    behavior: f
  }));
}
export {
  T as s
};
